import modal from './modal'
import course from './course'

export default {
  modal,
  course,
}

